<template>
    <div class="row">
      <div class="col-9 sm-6 lista">
        <div role="tablist" >
          <b-card no-body class="mb-1" v-for="falla in fallas" :key="falla.catastroUD_id">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block  @click="openCol(falla.catastroUD_id+'')" variant="info">{{falla.catastroUD_unico===0?falla.catastroUD_direccion:falla.catastroUD_unico}}</b-button>
            </b-card-header>
            <b-collapse :id="falla.catastroUD_id+''" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>{{falla.catastroUD_descripcion}}</b-card-text>
                <b-container fluid class="p-4 bg-dark">
                  <b-row>
                    <b-col v-for="(img2,index) in falla.catastro" :key="index">
                      <b-img thumbnail fluid :src="Ruta(img2.imagenesUD_ruta)" :alt="'Image'+index"></b-img>
                    </b-col>
                  </b-row>

                </b-container>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
      <b-card
        title="Filtros"
        style="max-width: 20rem;"
        class="col-4 col-sm"
      >
        <b-form @submit.prevent="onSubmit" @reset="onReset" >

          <b-form-group id="input-group-2" label="Ingrese Subcuenca" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="search.subcuenca"
              placeholder="Ingrese subcuenca"
              type="number"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Falla">
            <b-form-checkbox
              id="checkbox-1"
              v-model="search.falla"
              name="checkbox-1"
            >
              Falla en UD
            </b-form-checkbox>
          </b-form-group>
          <b-form-group id="idfecha" label="Ingrese fecha limite" label-for="input-2">
            <b-form-input
              id="fechaid"
              v-model="search.fecha"
              type="date"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="idtramo" label="Filtro de id de tramo" label-for="tramoid">
            <b-form-input
              id="tramoid"
              v-model="search.identifica"
              placeholder="Identifica"
              type="number"
            ></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">Enviar</b-button>
          <b-button class="float-right" type="reset" variant="danger">Limpiar</b-button>
        </b-form>

      </b-card>
    </div>
</template>

<script>
    import Http from "../Http";

    export default {
        name: "VistaCatastro",
        data:()=>({
            search:{
                subcuenca:'',
                falla:false,
                fecha:null,
                identifica:''
            },
            fallas:[]

        }),
        methods:{
            onSubmit(){
                let subcuenca = this.search.subcuenca.length==0? "na":this.search.subcuenca;
                let fecha = this.search.fecha==null? "na":this.search.fecha;
                let identifica = this.search.identifica.length==0?"na":this.search.identifica;

                Http.Http().get(`Catastroud/${subcuenca+''}/${this.search.falla.toString()}/${fecha}/${identifica}`).then(resp=>{
                    console.log(resp);
                    this.fallas = resp.data;
                })
            },
            onReset(){
                this.search= {
                    subcuenca:'',
                    falla:false,
                    fecha:null,
                    identifica:''
                }
            },
            openCol(idCollapse){
                this.$root.$emit('bv::toggle::collapse', idCollapse);
            },
            /**
             * @return {string}
             */
            Ruta(name){
                return `http://${Http.ip}/uploads/Images/${name}`
            }
        }
    }
</script>

<style scoped>
.lista{
  max-height: 800px;
  overflow: scroll;
}
</style>
